import React, { useState, useEffect, useRef } from 'react';
import Filter from '../../../images/icons/Filter.svg';
import FilterOptions from './FilterOptions';
import moment from 'moment';
import * as _ from 'lodash'

const CommonFilter = ({ onClikFilter, removeFilter,deleteSelectedDateFilter,deleteSelectedActivityFilter }) => {
  const [showOptions, setShowOptions] = useState(false);
  const [lastHighlightedTimeLine, setLastHighlightedTimeLine] = useState(0);
  const [flexTimeLine, setFlexTimeLine] = useState(false);
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [HighlightedText, setHighlightedText] = useState('TODAY');
  const [activityValues, setActivityValues] = useState({
    all: false,
    CREATED: false,
    APPLICANT_ADDED: false,
    DOC_UPLOADED: false,
    DOC_OCR_SUCCEEDED: false,
    DOC_OCR_FAILED: false,
    DATA_UPDATED: false,
    DATA_VERIFIED: false,
    DATA_VERIFICATION_FAILED: false,
    STATUS_CHANGED: false
  });
  const [userType, setUserType] = useState({
    rm: false,
    bp: false,
    cm: false
  });
  const myref = useRef(null);

  const closeOnClickOutside = e => {
    if (myref.current && myref.current.contains(e.target)) {
      return;
    } else {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', closeOnClickOutside, true);
    return () => {
      document.removeEventListener('mousedown', closeOnClickOutside, true);
    };
  }, []);

  useEffect(()=>{
    if(deleteSelectedDateFilter){
    setStartDate((moment().format('YYYY-MM-DD')))
    setEndDate((moment().format('YYYY-MM-DD')))
    }
  },[deleteSelectedDateFilter])

  useEffect(()=>{
    if(deleteSelectedActivityFilter){
    let temp = Object.assign({}, activityValues);
     temp = _.mapValues(temp, () => false);
     setActivityValues(temp)
    }
  },[deleteSelectedActivityFilter])

  return (
    <>
      <div
        ref={myref}
        className="w-full bg-black-1003 font-roboto font-normal flex flex-col justify-start relative rounded cursor-pointer"
        style={{
          paddingTop: '7px',
          paddingBottom: '7px'
        }}
        onClick={() => setShowOptions(!showOptions)}
      >
        <div className="flex flex-row justify-around  w-33  ">
          <p className="text-blue-1101 text-sm">Filter</p>
          <img src={Filter} alt="Y" />
        </div>

        {showOptions && (
          <FilterOptions
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            HighlightedText={HighlightedText}
            setHighlightedText={setHighlightedText}
            setShowOptions={setShowOptions}
            lastHighlightedTimeLine={lastHighlightedTimeLine}
            setLastHighlightedTimeLine={setLastHighlightedTimeLine}
            flexTimeLine={flexTimeLine}
            setFlexTimeLine={setFlexTimeLine}
            onClikFilter={filterData => onClikFilter(filterData)}
            removeFilter={() => removeFilter()}
            activityValues={activityValues}
            setActivityValues={setActivityValues}
            userType={userType}
            setUserType={setUserType}
          />
        )}
      </div>
    </>
  );
};

export default React.memo(CommonFilter);
